import { routes } from "@/apps/dashboard/user/routing/routes";

const router = [
  {
    ...routes.importUsers,
    component: () =>
      import(
        /* webpackChunkName: "db-import-users" */ "@/apps/dashboard/user/view/pages/ImportUsers/ImportUsersPage.vue"
      ),
  },
];

export default router;
